"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldGetProps = exports.getProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const shouldGetProps = (PageLayout, ChildPage, props) => {
  return PageLayout.shouldGetProps(props) || (ChildPage.shouldGetProps !== undefined ? ChildPage.shouldGetProps(props) : false);
};
exports.shouldGetProps = shouldGetProps;
const getProps = exports.getProps = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (PageLayout, ChildPage, props) {
    const allProps = yield Promise.all([PageLayout.getProps(props).catch(() => {}), ChildPage.getProps !== undefined ? ChildPage.getProps(props).catch(() => {}) : new Promise(resolve => resolve({}))]);
    return _objectSpread(_objectSpread({}, allProps[0]), allProps[1]);
  });
  return function getProps(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();